export default __webpack_public_path__ + "static/ferrari-f1d27c9273ed8525d0a79e878fbc9922.png";